import { BaseProps } from "./BaseProps";
import "../../../styles/actionbar/item.css";

export { Text };
type Props = {
  onClick?: Function;
} & BaseProps;

const Text = (props: Props) => {
  const contents = <span data-abi-title>{props.children}</span>;
  const className = `actionBarItem ${props.disabled ? "disabled" : ""}`;
  if (props.subCategory) {
    return (
      <li
        className={className}
        style={props.style}
        onClick={() => !props.disabled && props.onClick && props.onClick()}
      >
        {contents}
      </li>
    );
  } else {
    return (
      <div
        className={className}
        style={props.style}
        onClick={() => !props.disabled && props.onClick && props.onClick()}
      >
        {contents}
      </div>
    );
  }
};
